// extracted by mini-css-extract-plugin
export default {"cls1":"Q8Mpxo2PIG24KDdmxDWI","cls2":"T4itzNU_JuSaGgfj4RF6 Q8Mpxo2PIG24KDdmxDWI"};